import "./01_navigationBar.css"

import { useState, useEffect, useRef } from "react";

import logo from "../../assets/images/logo_2.png"
import NavMenu from "../../assets/images/more.png";

export default function NavigationBar() {
      const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
      const headerRef = useRef(null);
      const mobheaderRef = useRef(null);
    
      /* Lock body scroll when mobile menu is open */
      useEffect(() => {
        document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
    
        return () => {
          document.body.style.overflow = "";
        };
      }, [isMobileMenuOpen]);
    
      /* Hide / show navbar on scroll */
      useEffect(() => {
        let lastScrollY = window.scrollY;
    
        const handleScroll = () => {
          if (!headerRef.current) return;
    
          if (window.scrollY > lastScrollY) {
            headerRef.current.classList.add("nav--hidden");
          } else {
            headerRef.current.classList.remove("nav--hidden");
          }
    
          lastScrollY = window.scrollY;
        };
    
        window.addEventListener("scroll", handleScroll);
    
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
    
        /* Hide / show navbar on scroll */
      useEffect(() => {
        let lastScrollY = window.scrollY;
    
        const handleScroll = () => {
          if (!mobheaderRef.current) return;
    
          if (window.scrollY > lastScrollY) {
            mobheaderRef.current.classList.add("nav--hidden");
          } else {
            mobheaderRef.current.classList.remove("nav--hidden");
          }
    
          lastScrollY = window.scrollY;
        };
    
        window.addEventListener("scroll", handleScroll);
    
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
    return (
        <div>
            <div ref={headerRef} className="NavigationBar-Desktop-Main">
                <a href="/"><img src={logo} alt="" /></a>
                <div className="NavigationBar-Desktop-Side">
                    <a className="Navigations" href="/">home</a>
                    <a className="Navigations" href="/about">about</a>
                    <a className="Navigations" href="/contact">contact</a>
                    <a className="Navigations" href="/our-process">Our Process</a>
                    <a className="Navigations" href="/hearing-aids-products">Types of Hearing Aids</a>
                    <a className="Navigations" href="/hearing-solutions">Hearing Solutions</a>
                    <a href="/appointment"><button>Book an appointment</button></a>
                </div>
            </div>

            <div className="NavigationBar-Balancer"></div>

            {/* Mobile Header */}
            <div ref={mobheaderRef} className="Navigationbar-Mobile-Icon">
                <a href="/"><img src={logo} alt="" /></a>
                <div onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
                <img src={NavMenu} alt="Menu" />
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="Navigationbar-Mobile">
                <div className="Navigationbar-Mobile-Section">
                    <a href="/"            onClick={() => setMobileMenuOpen(false)}>home</a>
                    <a href="/about"       onClick={() => setMobileMenuOpen(false)}>about</a>
                    <a href="/contact"     onClick={() => setMobileMenuOpen(false)}>contact</a>
                    <a href="/our-process"     onClick={() => setMobileMenuOpen(false)}>Our Process</a>
                    <a href="/hearing-aids-products"     onClick={() => setMobileMenuOpen(false)}>Types of Hearing Aids</a>
                    <a href="/hearing-solutions"     onClick={() => setMobileMenuOpen(false)}>Hearing Solutions</a>
                    <a href="/appointment" onClick={() => setMobileMenuOpen(false)}>Book an appointment</a>
                </div>
                </div>
            )}
        </div>
    );
}